<template>
<div>
  <Modal v-model="modal" :title="$t('PB_Select_Employee_Search')" width="92%" :closable='false' :mask-closable="false"><!-- 选择员工 -->
    <Form :model="modalFormItem" :label-width="100">
      <Row :gutter="20"  >
        <Col :xs="24" :sm="24" :md="12" :lg="6">
          <FormItem :label="$t('BU')"><!-- 业务单元 -->
            <Select v-model="modalFormItem.businessUnit" clearable style="width:100%">
              <Option v-for="item in businessUnitList" :value="item.ch_value" :key="item.code">{{lang == 'zh' ? item.ch_value : item.en_value}}</Option>
            </Select>
          </FormItem>
        </Col>
        <Col :xs="24" :sm="24" :md="12" :lg="6">
          <FormItem :label="$t('Department')"><!-- 大区 -->
            <Select v-model="modalFormItem.department" clearable style="width:100%">
              <Option v-for="item in departmentList" :value="item.ch_value" :key="item.code">{{lang == 'zh' ? item.ch_value : item.en_value}}</Option>
            </Select>
          </FormItem>
        </Col>
        <Col :xs="24" :sm="24" :md="12" :lg="6">
          <FormItem :label="$t('Management_Level')"><!-- 管理层级 -->
            <Select v-model="modalFormItem.hrmanage" clearable style="width:100%">
              <Option v-for="item in ManagementLevel" :value="item.ch_value" :key="item.code">{{item.ch_value}}</Option>
            </Select>
          </FormItem>
        </Col>
        <Col :xs="24" :sm="24" :md="12" :lg="6">
          <FormItem :label="$t('Position')"><!-- 职位 -->
            <Input v-model="modalFormItem.position" />
            <!-- <Select v-model="modalFormItem.position" clearable style="width:100%">
              <Option v-for="item in positionList" :value="item.ch_value" :key="item.code">{{item.ch_value}}</Option>
            </Select> -->
          </FormItem>
        </Col>
        <Col  :xs="24" :sm="24" :md="12" :lg="6">
          <FormItem :label="$t('Employee_Code')"><!-- 员工号 -->
            <Input type="text" v-model="modalFormItem.empCode" />
          </FormItem>
        </Col>
        <Col :xs="24" :sm="24" :md="12" :lg="6">
          <FormItem :label="$t('Name')"><!-- 姓名 -->
            <Input type="text" v-model="modalFormItem.userName" />
          </FormItem>
        </Col>
        <Col :xs="24" :sm="24" :md="12" :lg="6">
          <FormItem :label="$t('English_Name')"><!-- 英文名 -->
            <Input type="text" v-model="modalFormItem.eName" />
          </FormItem>
        </Col>
        <!-- <Col :xs="24" :sm="24" :md="12" :lg="6">
          <FormItem :label="$t('Band')">
            <Select v-model="modalFormItem.hcmBand" clearable style="width:100%">
              <Option v-for="item in Band" :value="item.ch_value" :key="item.code">{{item.ch_value}}</Option>
            </Select>
          </FormItem>
        </Col> -->
        <Col  :xs="24" :sm="24" :md="12" :lg="6">
            <FormItem :label="$t('Line_Manager')"><!-- 直接上级 -->
                <Input type="text" v-model="modalFormItem.dirSupName" search enter-button clearable readonly @on-clear="dirClear()" @on-search="dirSearch"/>
            </FormItem>
            <p style="font-size:12px;color:red;margin-top:-15px;margin-bottom:10px">{{$t('PB_longText31')}}<!-- *默认显示选择人员的所有下属，如需进一步筛选，请选择汇报层级 --></p>
        </Col>
        <Col :xs="24" :sm="24" :md="12" :lg="6">
            <FormItem :label="$t('Reporting_Line')"><!-- 汇报层级 -->
                <Select v-model="modalFormItem.levelNum" multiple clearable >
                    <Option v-for="item in Level" :value="item.code" :key="item.code">{{lang=="zh"?item.ch_value:item.en_value}}</Option>
                </Select>
            </FormItem>
        </Col>
        <Col :xs="24" :sm="24" :md="12" :lg="6" style="margin-bottom:20px">
          <div style="display:flex;justify-content: flex-start;">
            <Button @click="pageInfo.pageNo=1,getData()"><!-- 检 索 -->{{$t('Search')}}</Button>
            <Button @click="handleReset()"><!-- 清空检索 -->{{$t('PB_Clear')}}</Button>
          </div>
        </Col>
        
      </Row>
      <!-- <FormItem label="职能">
        <Select v-model="modalFormItem.code3" style="width:200px">
          <Option v-for="item in list" :value="item.value" :key="item.value">{{item.label}}</Option>
        </Select>
      </FormItem> -->
    </Form>
    <Table highlight-row border :columns="modelColumns" :data="modelData" @on-select-cancel="TableSelectCancelRow" 
    @on-select-all-cancel="cancelAll"  @on-select-all="selsetAll" @on-select="peoOnSelectRow"
     @on-selection-change="itemClick" ref="selection" :loading="loading">
      <template slot="action1" slot-scope="{ row, index }">
        <Icon size="26" color="#006B37" type="md-menu" @click="onSelect(row,index)" />
      </template>
    </Table>
    <div style="display: flex;justify-content: end;margin-top: 30px;">
      <Page :current='pageInfo.pageNo' :total="total" @on-change="pageChange"></Page>
    </div>

    <div slot="footer">
      <Button type="text" @click="handleConfirm"><!-- 确认 -->{{$t('Confirm')}}</Button>           
      <Button type="text" @click="handleCancle"><!-- 取消 -->{{$t('Cancel')}}</Button>  
    </div>
  </Modal>
  <DirModalComponent ref="DirModalComponent" @selectRow="dirSelect"></DirModalComponent>
  </div>
</template>

<script>
import DirModalComponent from "../components/modalComponents/DirModalComponent.vue";
import axios from 'axios'
export default {
  components:{DirModalComponent},
  data() {
    return {
      loading:false,
      modal: false,
      modalFormItem: {
        dirSupName:'',
        levelNum:[]
      },
      modelColumns: [
        // {
        //   type: "selection",
        //   minWidth: 60,
        //   align: "center"
        // },
        {
          title: "工号",
          key: "empCode",
          align: "center",
          minWidth: 200
        },
        {
          title: "姓名",
          key: "userName",
          align: "center",
          minWidth: 200
        },
        {
          title: "英文名",
          key: "eName",
          align: "center",
          minWidth: 200
        },
        {
          title: "职位",
          key: "position",
          align: "center",
          minWidth: 200
        },
        {
          title: "职位",/* 职位 */
          key: "positionETitle",
          align: "center",
          minWidth: 200
        },
        {
          title: this.$t('Band'),/* Band */
          key: "hcmBand",
          align: "center",
          minWidth: 200
        },
        {
          title: this.$t('TalentCategory'),/* Band */
          key:"talentCategoryName",
          align: "center",
          minWidth: 200
        }
      ],
      modelData: [],
      pageInfo: {
          itemCount: 0,
          pageNo: 1,
          pageSize: 10,
      },
      total: 0,
      list:[],
      positionList:[],
      ApplyStatus :[],
      departmentList:[],

      businessUnitList :[],
      Level:[],
      ManagementLevel:[],
      selectList:[],
      Band:[],
      successorPeople:'2',
      positionCode:'',
      successorLevel:'',
      talentInventoryId:'',
      immediateSerialnumber:'',
    };
  },
  computed:{
    columnsLang(){
      return [
        {
          title: this.$t('Employee_Code'),/* 员工号 */
          key: "empCode",
          align: "center",
          minWidth: 200
        },
        {
          title: this.$t('Name'),/* 姓名 */
          key: "userName",
          align: "center",
          minWidth: 200
        },
        {
          title: this.$t('English_Name'),/* 姓名 */
          key: "eName",
          align: "center",
          minWidth: 200
        },
        {
          title: this.$t('Position_Name_Chinese'),/* 职位 */
          key: "position",
          align: "center",
          minWidth: 200
        },
        {
          title: this.$t('Position_Name_English'),/* 职位 */
          key: "positionETitle",
          align: "center",
          minWidth: 200
        },
        {
          title: this.$t('Band'),/* Band */
          key: "hcmBand",
          align: "center",
          minWidth: 200
        },
        {
          title: this.$t('TalentCategory'),/* Band */
          key:  "talentCategoryEName",
          align: "center",
          minWidth: 200
        }
      ]
    },
    lang(){
      return this.$store.getters.selectLangeData
    },
  },
  created(){
    // this.getData()
    this.getListData()
  },
  mounted(){
    this.modelColumns.forEach(res => {
      this.columnsLang.forEach(el => {
        if(res.key==el.key){
          res.title=el.title
        }
      })
    })
  },
  watch: {
      selectList: {
        handler(newVal, oldVal) {
          newVal.forEach(res => {
            this.modelData.forEach((el, index) => {
              el._checked = false
              if (el.empCode === res.empCode) {
                  this.$refs.selection.objData[index]._isChecked = true
                }
            })
          })
        },
        deep: true,
        immediate: true
      },
      '$i18n.locale'(newValue) {
        this.modelColumns.forEach(res => {
          this.columnsLang.forEach(el => {
            if(res.key==el.key){
              res.title=el.title
            }
          })
        })
      }
  },
  methods: {
    getListData(){
        axios.post("/achReport/selectAchReportLabelInfo", {}).then((res) => {
            if (res) {
                this.positionList=res.positionList
                this.departmentList=res.departmentList
                this.businessUnitList=res.businessUnitList
                this.Level=res.Level
                this.Band=res.Band
                this.ManagementLevel=res.ManagementLevel
            }
        })
    },
    getData(){
      let obj={ 
        ...this.modalFormItem,
        ...this.pageInfo,
        successorPeople:this.successorPeople,
        positionCode:this.positionCode,
        successorLevel:this.successorLevel,
        talentInventoryId:this.talentInventoryId,
        immediateSerialnumber:this.immediateSerialnumber
      }
      this.loading=true
      axios.post("/TalentInventory/selectUserList", obj).then((res) => {
        this.loading=false
          if (res) {
              this.modelData=res.data
              // this.modelData.forEach(el => {
              //   el._checked=false
              // })
              this.$nextTick(() => {
                this.selectList.forEach(res => {
                  this.modelData.forEach((el, index) => {
                    el._checked = false
                    if (el.empCode === res.empCode) {
                        this.$refs.selection.objData[index]._isChecked = true
                      }
                  })
                })
              })
              this.total = parseInt(res.pageInfo.total)
          }
      })
    },
    targetItemChange(row, index, key) {
      key && this.$set(this.columnsData[index], key, row[`${key}`]);
    },
    onSelect(row,index){
      this.modal=false
      this.modelColumns.splice(0, 1);
      this.$emit('onSelect',row)
    },
    pageChange(val){
        this.pageInfo.pageNo = val;
        this.getData()
    },
    handleConfirm(){
      this.modelColumns.splice(0, 1);
      this.modal=false
      this.$emit('onSelectList',JSON.parse(JSON.stringify(this.selectList)))
      this.$nextTick(() => {
        this.$refs.selection.selectAll(false);
      })
      this.pageInfo.pageNo=1
    },
    handleCancle(){
      this.modelColumns.splice(0, 1);
      this.modal=false
      this.$nextTick(() => {
        this.$refs.selection.selectAll(false);
      })
      this.pageInfo.pageNo=1
    },
    itemClick(list){
      // let arr=this.selectList
      // list.forEach(el => {
      //   arr.forEach(res => {
      //     if(el.serialnumber!=res.serialnumber){
      //           this.selectList.push(el)
      //       }
      //   })
          
      // })
      // console.log(this.selectList)
      // this.selectList=JSON.parse(JSON.stringify(list))
    },
    TableSelectCancelRow(selection, row){
        this.selectList.forEach((el,index) => {
            if(el.serialnumber==row.serialnumber){
                this.selectList.splice(index,1)
            }
        })
    },
    peoOnSelectRow(selection,row) {
        if (!this.selectList.includes(row.serialnumber)) {
            this.selectList.push(row)
        }
    },
    selsetAll(selection){
        this.modelData.forEach(el => {
            this.selectList.push(el)
        })
        let map = new Map();
        for (let item of this.selectList) {
            map.set(item.serialnumber, item);
        }
        this.selectList = [...map.values()];
    },
    cancelAll(selection){
        this.modelData.forEach(row =>{
            this.selectList.forEach((el,index) => {
                if(el.serialnumber==row.serialnumber){
                    this.selectList.splice(index,1)
                }
            })
        })
    },
    dirSearch(){
        this.$refs.DirModalComponent.modalShow=true
    },
    dirSelect(item){
        let json=JSON.parse(item)
        this.modalFormItem.dirSupName=json.userName
        this.modalFormItem.dirSupSerialnumber=json.dirSupSerialnumber
        this.$set(this.modalFormItem,'dirSupName',json.userName)
    },
    dirClear(){
        this.modalFormItem.dirSupSerialnumber=''
    },
    handleReset(){
      this.modalFormItem={
        dirSupName:'',
        levelNum:[]
      }
      // this.pageInfo.pageNo=1
      // this.getData()
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/process/performanceManagement/components/selectPeople.vue